/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABVUlEQVR4nM3Vv0oDQRAG8IsoNoKNjeADaCOIjZVpE7j5s8JlJqY/EMHSNvoI1qmMRPMEVhZib2MnFlrYBewiNuZkV4QjXC7J3RZ+MO3v4/aWnSD4p6kA6TmwvoYHzU2vchzHS8jaRdbETshS94ZHUbSCpLd/OLKOwrC55gU3prWOpI8pPAHSZy84s2whyVsadwWsl6VxMI09ZBmM478FclQKR1QDpJ9ZuBvUneK40RMg+Z6Isw6r1epiEbsCJGc5cOKG5H5uuVarLQNrfyrOruB67gJg7c2E8+QBlk5OgXTKF2hv/i8jvZkR79tjLnJ0D1Nxkot2u71Q9HEb5uAjID0Niob5cDcH/0LT0KBM0OhxNi4fiI39UrgrILnKKHgH0O3SuCtgfRm750/GtDa84HaZ2J+YKriLomjVC+4KWOopvGtvlDfcxi4au9jtgrePoFfcV34AwlVSD7Oer9EAAAAASUVORK5CYII=)
 */
export const FlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7.65 21.75a1 1 0 0 0 1.64.96l11.24-9.96a1 1 0 0 0-.66-1.75h-4.81a.5.5 0 0 1-.5-.6l1.79-8.15a1 1 0 0 0-1.64-.96L3.47 11.25A1 1 0 0 0 4.13 13h4.81c.32 0 .56.3.5.6l-1.79 8.15Z"
        className={colorClass}
      />
    </svg>
  );
};
